import {Component} from 'preact';
import cx from 'classnames';
import Icon from '@components/common/Icon';
import tw from '@root/tailwind.config';
import invoke from 'lodash.invoke';

const QTY_LABEL = upi.i18n.getTextFromKey( 'abbr-quantity', 'Qty' );
const btnClass = 'icon justify-center flex-1 p-3 text-white rounded-sm focus:outline t-opacity t-duration-short hover:opacity-80';

// bg-grey-darker hover:bg-grey-dark

class QtyToggle extends Component {
    constructor ( props ) {
        super( props );

        this.onFocus = this.onFocus.bind( this );
        this.onChange = this.onChange.bind( this );
        this.decrement = this.decrement.bind( this );
        this.increment = this.increment.bind( this );

        this.state = {
            value: props.value || props.min,
            disabled: props.max === 0
        };
    }

    componentWillReceiveProps ( nextProps, nextContext ) {
        this.setState( () => ({value: nextProps.value}) );
    }

    increment ( e ) {
        const value = parseInt( this.state.value + 1, 10 );
        this.setMinMaxValue( value );

        invoke( this.props, 'onIncrement', value, e );
    }

    decrement ( e ) {
        const value = parseInt( this.state.value - 1, 10 );
        this.setMinMaxValue( value );

        invoke( this.props, 'onDecrement', value, e );
    }

    onFocus ( e ) {
        this.input.select();
        invoke( this.props, 'onFocus', e );
    }

    onChange ( {currentTarget} ) {
        this.setMinMaxValue( currentTarget.value );
    }

    setMinMaxValue ( value ) {
        const {min, max} = this.props;
        value = Math.min( Math.max( value, min ), max );

        this.setState( {value}, () =>
            invoke( this.props, 'onChange', value )
        );
    }

    render ( props ) {
        const fieldProps = {
            id: props.id,
            name: props.id,
            min: props.min,
            max: props.max
        };

        const decrementState = this.state.disabled;
        const incrementState = this.state.disabled || this.state.value >= props.max;
        const decrementBtnClass = cx(
            btnClass, `bg-${props.color}`, 'rounded-r-none', {'bg-grey-lighter': decrementState}
        );
        const incrementBtnClass = cx(
            btnClass, `bg-${props.color}`, 'rounded-l-none', {'bg-grey-lighter': incrementState}
        )

        return (
            <fieldset className={`qty-toggle flex flex-col flex-0 justify-center w-full m-0 ${props.className}`}>
                <label htmlFor="skuQty" className="text-xs uppercase self-center w-full text-center">{QTY_LABEL}</label>
                <div className="flex w-full">
                    <button data-testid={`decrement-${props.id}`}
                            disabled={decrementState}
                            className={decrementBtnClass}
                            onClick={this.decrement}>
                        <Icon.ui name="minus" className="align-top" wrapperClassName="block h-3"/>
                    </button>
                    <input value={this.state.value}
                           className="flex-1 text-center"
                           ref={ref => this.input = ref}
                           style={{
                               margin: 0,
                               borderRadius: 0,
                               fontWeight: '600',
                               borderWidth: '1px 0',
                               minWidth: '48px',
                               maxWidth: '96px'
                           }}
                           onFocus={this.onFocus}
                           onChange={this.onChange}
                           type="number" {...fieldProps} />
                    <button data-testid={`increment-${props.id}`}
                            disabled={incrementState}
                            className={incrementBtnClass}
                            onClick={this.increment}>
                        <Icon.ui name="plus" className="align-top" wrapperClassName="block h-3"/>
                    </button>
                </div>
            </fieldset>
        );
    }
}

QtyToggle.defaultProps = {
    className: '',
    id: 'skuQty',
    min: 0,
    max: 99,
    color: 'grey-darker',
    onChange: () => {
    },
    onFocus: () => {
    }
};

export default QtyToggle;
